// Mock data for Pratish Jain Portfolio

export const testimonials = [
  {
    id: 1,
    name: "Ankit Sharma",
    role: "Head of Marketing",
    company: "Engati Technologies Pvt. Ltd.",
    content: "Pratish directly reported to me on his time at Engati. He is an analytical and creative, and has a good work ethic - making him a good fit for growing marketing teams. One particular thing that I appreciate about him as a marketer in his early years is that he is eager to learn and doesn't shy away from additional projects but rather sees them as learning opportunities. While at Engati, he was responsible for authoring or revamping our top 3 other out of 5 blogs. And as marketing associate he looked at other projects as well- primarily events.",
    image: null
  },
  {
    id: 2,
    name: "Shubhangi Srivastava",
    role: "Marketing",
    company: "Engati Technologies Pvt. Ltd.",
    content: "Pratish joined Engati to help us scale our content engine. He was quick to grasp the product as well as the target audience and our approach to market to them. His writing is clear, well articulated with good understanding on where to pitch the product. Beyond blogs, Pratish successfully took on initiatives like inbound email drip campaigns, e-books, chat flows for lead generation, and more. He's a resourceful individual with a constant drive to learn, grow, and take on new challenges.",
    image: null
  },
  {
    id: 3,
    name: "Aravind Balakrishnan",
    role: "Digital Marketing Manager",
    company: "",
    content: "Working with Pratish was a great experience. He doesn't just write, but understands strategy. Every piece of content was purposeful, audience-focused, and impactful.",
    image: null
  },
  {
    id: 4,
    name: "Shyam Singh Bhati",
    role: "Building OMG AI for E-Com Brands",
    company: "WODO Marketing Agency",
    content: "I am pleased to recommend Pratish Jain, who interned as a Content & Copy Writer at WODO. During his time with us, Pratish demonstrated exceptional dedication and consistently delivered high-quality work. He had a keen understanding of our clients' requirements, which was evident in the content he produced. Pratish worked on multiple client projects simultaneously and managed his workload effectively. His communication skills on client calls were excellent, enabling smooth interactions and ensuring clarity. His ability to conduct thorough research on clients was particularly impressive and contributed significantly to the quality of his work.",
    image: null
  }
];

export const caseStudies = [
  {
    id: 1,
    client: "Engati",
    period: "August 2024 - January 2025 (6 months)",
    challenge: "Build a content engine from scratch to drive organic traffic and generate qualified inbound leads for an enterprise conversational AI platform.",
    solution: [
      "Developed comprehensive SEO content strategy with keyword research and topic clustering",
      "Authored 20 high-quality SEO blogs targeting buyer intent keywords",
      "Created 3 lead magnet eBooks addressing key customer pain points",
      "Led martech project implementing chatbot for lead qualification",
      "Organized META x Engati event with 130+ attendees"
    ],
    outcomes: [
      "22.1M organic impressions generated",
      "83.1K clicks from search results",
      "256 qualified leads from eBooks alone",
      "208 leads from chatbot in 3 months (75% qualified)",
      "3 of top 5 best-performing blogs generating 80% of inbound leads"
    ],
    testimonial: {
      name: "Ankit Sharma",
      role: "Head of Marketing at StackBOX",
      quote: "Pratish was responsible for authoring or revamping our top 3 out of 5 blogs. He is analytical and creative with a good work ethic."
    },
    tags: ["SEO Content", "Lead Generation", "B2B SaaS", "MarTech"]
  },
  {
    id: 2,
    client: "helo.ai",
    period: "February 2025 - February 2026 (6 months)",
    challenge: "Launch organic growth strategy for a new AI-powered customer support platform with zero existing traffic and minimal brand awareness.",
    solution: [
      "Rebuilt website from scratch with SEO best practices",
      "Executed comprehensive on-page and off-page SEO strategy",
      "Created 50+ SEO-optimized blogs, eBooks, and content assets",
      "Implemented conversion rate optimization (CRO) tactics",
      "Scaled LinkedIn from 4K to 11K+ followers through strategic content"
    ],
    outcomes: [
      "0 to 129K monthly impressions in 8 months",
      "0 to 3K+ monthly organic traffic",
      "20+ qualified leads per month from 5th month onwards",
      "Multiple page 1 Google rankings and AI snippet features",
      "175% LinkedIn follower growth"
    ],
    testimonial: {
      name: "Shubhangi Srivastava",
      role: "Marketing at SiftHub",
      quote: "His writing is clear, well articulated with good understanding on where to pitch the product. He's a resourceful individual with a constant drive to learn."
    },
    tags: ["SEO Strategy", "Content Marketing", "CRO", "Social Media"]
  },
  {
    id: 3,
    client: "Acviss",
    period: "2024 - Present",
    challenge: "Strengthen organic visibility and improve inbound lead generation for a brand protection and anti-counterfeit technology company through strategic content and conversion-focused assets.",
    solution: [
      "Developed SEO blog strategy aligned with high-intent cybersecurity and brand protection keywords",
      "Suggested content topics based on search demand, ICP pain points, and funnel stages",
      "Wrote and optimized blogs for organic ranking and product education",
      "Created lead magnet ideas and downloadable content assets for lead capture",
      "Recommended CRO improvements for landing pages and blog-to-demo conversion paths",
      "Improved internal linking and CTA placement to increase content-assisted conversions"
    ],
    outcomes: [
      "Improved organic visibility across brand protection and traceability topics",
      "Increased demo and consultation intent from content landing pages",
      "Stronger top-of-funnel lead acquisition through lead magnets",
      "Better visitor-to-lead conversion flow from blog traffic"
    ],
    testimonial: null,
    tags: ["SEO Content", "Topic Strategy", "Lead Magnets", "CRO"]
  },
  {
    id: 4,
    client: "B-Live",
    period: "2024",
    challenge: "Improve website structure and content clarity for an EV mobility brand to strengthen SEO performance, improve discoverability, and support better conversion journeys.",
    solution: [
      "Enhanced overall website structure for better crawlability and user navigation",
      "Reworked key landing page content for clarity, SEO, and conversion intent",
      "Improved heading hierarchy, internal linking, and content flow",
      "Optimized service and product pages with keyword-focused copy",
      "Suggested UX-aligned content changes to reduce friction in the user journey",
      "Strengthened informational pages for non-branded search discoverability"
    ],
    outcomes: [
      "Better structured website architecture for SEO scalability",
      "Improved discoverability of core product and service pages",
      "Higher engagement through clearer navigation and content hierarchy",
      "Stronger conversion pathways from organic landing pages"
    ],
    testimonial: null,
    tags: ["Website Content", "SEO Optimization", "Site Architecture"]
  },
  {
    id: 5,
    client: "Sakshi Handloom",
    period: "2024",
    challenge: "Revamp and optimize an e-commerce handloom website to improve organic rankings, enhance category discoverability, and drive more product-led conversions.",
    solution: [
      "Led complete e-commerce SEO optimization across collection and product pages",
      "Revamped website content to improve category clarity and search relevance",
      "Optimized product descriptions for keyword targeting and purchase intent",
      "Improved metadata, schema recommendations, and image SEO",
      "Reworked homepage and category page messaging for stronger merchandising",
      "Suggested better content structure for collections, filters, and navigation"
    ],
    outcomes: [
      "Improved product and collection page discoverability",
      "Better rankings for high-intent handloom and ethnic fashion searches",
      "Improved product page engagement and conversion potential",
      "Stronger SEO foundation for long-term catalog growth"
    ],
    testimonial: null,
    tags: ["E-Commerce SEO", "Website Revamp", "Content Strategy"]
  },
  {
    id: 6,
    client: "Utopia Choice",
    period: "2024",
    challenge: "Optimize and restructure the e-commerce website to improve search visibility, enhance category performance, and improve purchase journeys.",
    solution: [
      "Executed end-to-end e-commerce SEO optimization",
      "Revamped website messaging and category page content",
      "Improved product page content depth and keyword targeting",
      "Suggested collection structure and navigation improvements",
      "Optimized metadata, internal linking, and page hierarchy",
      "Improved conversion-oriented copy across landing and product pages"
    ],
    outcomes: [
      "Improved rankings across commercial search terms",
      "Better category discoverability and navigation depth",
      "Increased product page relevance for search and shopping intent",
      "Improved SEO-led purchase journey"
    ],
    testimonial: null,
    tags: ["E-Commerce SEO", "Website Revamp", "Conversion Content"]
  },
  {
    id: 7,
    client: "Zunaisha",
    period: "2024",
    challenge: "Build a new website from scratch with strong information architecture, clear brand messaging, and conversion-friendly content.",
    solution: [
      "Planned complete website structure from scratch",
      "Suggested page hierarchy, navigation flow, and content blocks",
      "Contributed design direction ideas for better UX and storytelling",
      "Wrote complete website content aligned with brand voice",
      "Developed homepage, service, and about page messaging",
      "Structured conversion-focused CTAs and landing page content"
    ],
    outcomes: [
      "Successfully launched a structured SEO-friendly website",
      "Stronger brand positioning through clear messaging",
      "Better user journey from homepage to inquiry",
      "Scalable content foundation for future SEO growth"
    ],
    testimonial: null,
    tags: ["Website Strategy", "Content Architecture", "UX Content"]
  }
];

export const services = [
  {
    id: 1,
    title: "SEO Content Strategy",
    description: "Data-driven content roadmaps that turn search traffic into qualified pipeline.",
    features: [
      "Keyword research and search intent mapping",
      "Topic clusters and content architecture",
      "Competitor gap analysis",
      "Strategic content roadmap aligned with buyer journey"
    ]
  },
  {
    id: 2,
    title: "Lead Generation Content",
    description: "High-converting content assets designed to capture and nurture B2B SaaS leads.",
    features: [
      "Conversion-focused blog posts",
      "Lead magnet eBooks and guides",
      "Landing page content and copy",
      "Case studies and success stories"
    ]
  },
  {
    id: 3,
    title: "Analytics & CRO Optimization",
    description: "Turn content performance data into actionable growth strategies.",
    features: [
      "GA4 and Microsoft Clarity analysis",
      "User journey and behavior mapping",
      "Content refresh and optimization",
      "Conversion funnel improvement"
    ]
  },
  {
    id: 4,
    title: "LinkedIn Ghostwriting for CxOs",
    description: "Building executive presence and thought leadership for founders, directors, and high-level executives.",
    features: [
      "Custom content strategy aligned with personal and company brand",
      "Content tailored to get \"top voice\" badge",
      "Engaging, thought-provoking posts tailored for your audience",
      "🎁 Special Offer: 3 sample posts for free with no commitment"
    ]
  }
];

export const stats = [
  { label: "Organic Impressions", value: "100M+" },
  { label: "Words Written", value: "200K+" },
  { label: "Monthly Leads Generated", value: "150+" },
  { label: "Monthly Traffic Growth", value: "3K+" },
  { label: "Content & Growth Experience", value: "3+ Years" }
];

export const clients = [
  { id: 1, name: "Engati", logo: "/images/engati.svg" },
  { id: 2, name: "helo.ai", logo: "/images/helo-ai.svg" },
  { id: 3, name: "WODO", logo: "/images/wodo.png" },
  { id: 4, name: "Acviss", logo: "/images/acviss.svg" },
  { id: 5, name: "B-Live", logo: "/images/blive.svg" },
  { id: 6, name: "Fincept Pro", logo: "/images/fincept-pro.png" },
  { id: 7, name: "Gaav Naturals", logo: "/images/gaav-naturals.jpg" },
  { id: 8, name: "India Pavilion", logo: "/images/india-pavilion.png" },
  { id: 9, name: "Login Realty", logo: "/images/login-realty.webp" },
  { id: 10, name: "Mars", logo: "/images/mars.png" },
  { id: 11, name: "Marutee", logo: "/images/marutee.svg" },
  { id: 12, name: "Sakshi Handloom", logo: "/images/sakshi-handloom.jpg" },
  { id: 13, name: "Utopia Choice", logo: "/images/utopia-choice.png" },
  { id: 14, name: "Zunaisha", logo: "/images/zunaisha.webp" }
];

export const workExperience = [
  {
    id: 1,
    company: "Freelance",
    role: "Content Writer, Marketer & Consultant",
    duration: "August 2023 - Present",
    location: "Remote",
    achievements: [
      "Blogs & articles for B2B and D2C brands",
      "Website content and copy",
      "Social media content strategy",
      "Content strategy consulting"
    ]
  },
  {
    id: 2,
    company: "helo.ai by VivaConnect",
    role: "Brand & Content Manager",
    duration: "February 2025 - February 2026",
    location: "Mumbai",
    achievements: [
      "Revamped complete website from scratch",
      "Scaled LinkedIn from 4K to 11K+ followers",
      "Grew website from 0 to 129K impressions and 3K+ monthly traffic in 8 months",
      "Generated 20+ leads monthly from the 5th month onwards",
      "Authored 50+ SEO blogs, eBooks, and website assets with Google and AI snippet rankings",
      "Led GFF 2025 event generating 10,000+ leads with 60+ Lakhs budget"
    ]
  },
  {
    id: 3,
    company: "Engati Technologies Pvt. Ltd.",
    role: "Marketing Associate",
    duration: "August 2024 - January 2025",
    location: "Mumbai",
    achievements: [
      "Authored 20 SEO blogs generating 22.1M impressions and 83.1K clicks",
      "Wrote 3 of the top 5 best-performing blogs generating 80% of inbound leads",
      "Developed 3 eBooks contributing to 256 qualified leads",
      "Led martech project: website chatbot and WhatsApp chatbot generating 208 leads in 3 months (75% qualified)",
      "Organized META x Engati event with 130+ clients and prospects"
    ]
  },
  {
    id: 4,
    company: "WODO Marketing Agency",
    role: "Content Writer",
    duration: "January 2024 - April 2024",
    location: "Bangalore",
    achievements: [
      "Generated SEO-optimized blogs for multiple clients",
      "Created social media content across platforms",
      "Website and ad copywriting",
      "Content auditing and optimization"
    ]
  },
  {
    id: 5,
    company: "Shri Maninath Plastics Pvt. Ltd.",
    role: "Sales & Marketing Head",
    duration: "April 2022 - January 2024",
    location: "Mumbai",
    achievements: [
      "Promoted to Marketing Head within 6 months",
      "Generated revenue of INR 90 Lakhs within 9 months",
      "Managed B2B sales and lead generation",
      "Recruited and managed team of 4 people"
    ]
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "How to Turn SEO Content into a Lead Generation Engine",
    excerpt: "Most B2B SaaS companies focus on traffic. But traffic alone doesn't pay the bills. Here's how to create content that actually generates qualified leads.",
    category: "SEO Strategy",
    date: "2026-01-15",
    readTime: "8 min read",
    featured: true
  },
  {
    id: 2,
    title: "The Content Strategy Framework That Generated 256 Leads",
    excerpt: "A breakdown of the exact content strategy and lead magnet approach that helped Engati generate hundreds of qualified B2B leads.",
    category: "Lead Generation",
    date: "2026-01-10",
    readTime: "6 min read",
    featured: false
  },
  {
    id: 3,
    title: "Why Most B2B SaaS Content Fails (And How to Fix It)",
    excerpt: "After analyzing hundreds of B2B SaaS blogs, here are the 5 critical mistakes that prevent content from converting traffic into pipeline.",
    category: "Content Strategy",
    date: "2026-01-05",
    readTime: "7 min read",
    featured: false
  }
];

export const whyMePoints = [
  {
    title: "Content + Marketing Mindset",
    description: "Not just a writer—I think like a marketer. Every piece of content is designed to move prospects through your funnel."
  },
  {
    title: "Revenue-First Thinking",
    description: "Traffic is vanity. Leads are sanity. I focus on creating content that directly contributes to pipeline and revenue."
  },
  {
    title: "Buyer Intent Focus",
    description: "I map content to buyer journey stages, targeting keywords and topics that indicate purchase intent, not just information seeking."
  },
  {
    title: "Deep Analytics Insights",
    description: "From GA4 to Clarity to Search Console—I use data to continuously optimize content performance and user experience."
  },
  {
    title: "Strategic Recommendations",
    description: "Beyond writing, I provide strategic input on content systems, conversion optimization, and growth experiments."
  },
  {
    title: "B2B SaaS Specialization",
    description: "After working across D2C and B2B, I've found my expertise in B2B SaaS organic growth where content directly influences pipeline."
  }
];